<template>
  <span
    v-if="wonder.isEgypt"
  >
    <img
      :src="require(`@/assets/images/wonder/Egypt.png`)"
      alt=""
      :class="{
        'w-6 h-6': size === 'small',
        'w-8 h-8': size === 'large',
      }"
    >
  </span>
  <span
    v-else-if="wonder.isChina"
  >
    <img
      :src="require(`@/assets/images/wonder/China.png`)"
      alt=""
      :class="{
        'w-6 h-6': size === 'small',
        'w-8 h-8': size === 'large',
      }"
    >
  </span>
  <span
    v-else-if="wonder.isMaya"
  >
    <img
      :src="require(`@/assets/images/wonder/Mayan_Empire.png`)"
      alt=""
      :class="{
        'w-6 h-6': size === 'small',
        'w-8 h-8': size === 'large',
      }"
    >
  </span>
  <span
    v-else-if="wonder.isVikings"
  >
    <img
      :src="require(`@/assets/images/wonder/Viking_Kingdom.png`)"
      alt=""
      :class="{
        'w-6 h-6': size === 'small',
        'w-8 h-8': size === 'large',
      }"
    >
  </span>
  <span
    v-else-if="wonder.isArabia"
  >
    <img
      :src="require(`@/assets/images/wonder/Arabia.png`)"
      alt=""
      :class="{
        'w-6 h-6': size === 'small',
        'w-8 h-8': size === 'large',
      }"
    >
  </span>
</template>

<script>
export default {
  props: {
    wonder: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: 'small'
    }
  }
};
</script>
